import React, {useEffect, useContext, useState, Fragment, useRef} from "react";
import { Modal } from "react-bootstrap";


import cerrar from "../../assets/img/cerrar.svg";
import cerrar_conbg from "../../assets/img/cerrar_conbg.svg";

import ticketimg from "../../assets/img/ticketimg.png";
import plus from "../../assets/img/plus.svg";
import clip from "../../assets/img/clip.svg";
// import ticket from "../../assets/img/ticket.jpg";
import equal from "../../assets/img/equal.svg";
import ConexContext from "../../context/ConexContext";
// import clickOut from "../../assets/js/clickOut";
// import clickOut2 from "../../assets/js/cliclOut2";
import clickOut3 from "../../assets/js/cliclOut3";
import carga from "../../assets/img/carga.gif";
// import aspa2 from "../../assets/img/aspa2.png";
import validado from "../../assets/img/validado.svg"
import ticket2 from "../../assets/img/ticket.png"
import ModalSubirImagenes from "./ModalSubirImagenes";



const ModalPorTipo = (props) => {

    // CONEX
    const {peticion} = useContext(ConexContext);
    // STATE
    const [DatosFila, setDatosFila]=useState([]);// DATOS DE LAS FILAS
    const [DatosFilaExpan, setDatosFilaExpan]=useState(null);// DATOS PARA LA TARJETA DE INFORMACION
    const [Datos_IMAGENES, setDatos_IMAGENES]=useState([]); // DATOS IMAGENES
    const [Seleccionado, setSeleccionado]=useState(-1);// PARA VER QUE FILA TENEMOS PULSADA
    const [SinComentario, setSinComentario]=useState(true);// VARIABLE AUXILIAR PARA EL TEMA DEL COMENTARIO
    const [Comentario, setComentario]=useState("");// CONTENIDO DEL COMENTARIO
    const [GuardarComentario, setGuardarComentario]=useState(1);
    const [ImagenenAuxiliar, setImagenAuxiliar]=useState(null);// IMAGEN AUXILIAR QUE ESTA VINCULADA
    const [ContPag, setContPag]=useState(0); // CONTADOR DE PAGINACION
    const [modalSubirImagnes, setModalSubirImagnes] = useState(false);//Modal para el apartado "Subir Imagenes"
    const [modalSubirImagnesAux, setmodalSubirImagnesAux] = useState(false);//Modal para el apartado "Subir Imagenes"

    // REF
    const divSeleccionar = useRef(); //ref para quitar el seleccionado
    const divSeleccionar2 = useRef(); //ref para quitar el seleccionado
    const divSeleccionar3 = useRef(); //ref para quitar el seleccionado
    const divSeleccionar4 = useRef(); //ref para quitar el seleccionado
    const divComentario = useRef();
    // VARIABLES
    const Confs={
      campos:["i6operacion.nombre_comercio","i6operacion.fecha_ope","i6operacion.importe_liqui", "adjunto"],
    }
    // FUNCIONES
    //quita el seleccionado
    clickOut3(divSeleccionar, divSeleccionar2,  divSeleccionar3, divSeleccionar4, () => {
      setSeleccionado(-1);
      setDatosFilaExpan(null);
      // setImagenAuxiliar(null);
    });
    // Para cerrar el modal
    function cierra() {     
        props.onHide();
        setDatosFila([]);
    }
    // devuelve la fecha en formato dd/mm/aaaa
    function fechaEsp(date) {
        let s = date.getDate().toString().padStart(2, 0);
        s += "/" + (date.getMonth() + 1).toString().padStart(2, 0);
        s += "/" + date.getFullYear().toString().padStart(4, 0);
        return s;
    }
    // devuelve la fecha en formato aaaammdd
    function fechaDB(date) {
        let s = date.getFullYear().toString().padStart(4, 0);
        s += (date.getMonth() + 1).toString().padStart(2, 0);
        s += date.getDate().toString().padStart(2, 0);
        return s;
    }
    // devuelve la fecha en formato dd/mm/aaaa de un valor aaaammdd
      function fechaMostrar(date) {
        let s = date.toString().substring(9, 6);
        s += "/" + date.toString().substring(6, 4);
        s += "/" + date.toString().substring(4, 0);
        return s;
    }

    //EFFEC DE PRUEBA
    useEffect(() => {
      setDatosFila([]);
      setDatosFilaExpan(null);
      setImagenAuxiliar(null);
      setSeleccionado(-1);
      setContPag(0);
      setGuardarComentario(1);
      setSinComentario(false);
    }, [props.show])

    useEffect(() => {
      if(DatosFila.length > 0 && Seleccionado !== -1 && modalSubirImagnes===false && modalSubirImagnesAux){
        imagen_vinculada2(DatosFila[Seleccionado]["i6operacion.contador"], DatosFila[Seleccionado]["i6operacion.cod_ent"], DatosFila[Seleccionado]["i6operacion.importe_liqui"]);
        // imagenes2(DatosFila[Seleccionado]["i6operacion.importe_liqui"]);
        setmodalSubirImagnesAux(false);
      }
      // eslint-disable-next-line
    }, [modalSubirImagnes])


    useEffect(() => {
    // async function imagenes(){      
    //   let res=await peticion(`/bajarimagenes`, {method:'POST',json:props.Confs});
    //   if(res?.estado??true) return
    //   setDatos_IMAGENES(res["res"]);
    // }
    async function datos_fila(){      
      let res_datos_fila=await peticion(`/datos_fila?fechainicio=${fechaDB(props.date1)}&fechafin=${fechaDB(props.date2)}&variables_columna=${props.Columnas}&variable_nivel=${props.Nivel}`, {method:'POST',json:props.Confs});
      if(res_datos_fila?.estado??true) return
      setDatosFila(res_datos_fila["res"]);
    }

    if(!props.Fila | !props.show | !props.Columnas) return;
    datos_fila();
    // imagenes();
    
	}, [props.date1,props.date2, props.Confs, peticion, props.Fila, props.show, props.Columnas, props.Nivel])

    // FUNCIONES
   
    async function datos_fila_expe(contador, cod_ent){      
      let res=await peticion(`/datos_fila_expe?fechainicio=${fechaDB(props.date1)}&fechafin=${fechaDB(props.date2)}&variables_columna=${props.Columnas}&variable_nivel=${props.Nivel}&contador=${contador}&cod_ent=${cod_ent}`, {method:'POST',json:props.Confs});
      if(res?.estado??true) return
      setDatosFilaExpan(res["res"]);
    }
    
    async function imagenes2(valor_precio){
      let res=await peticion(`/bajarimagenes`, {method:'POST',json:props.Confs});
      if(res?.estado??true) return
      res["res"].sort((a, b) => {
        a = parseFloat(a["importe"]);
        b = parseFloat(b["importe"]);
        if (Math.abs(a-parseFloat(valor_precio)) === Math.abs(b-parseFloat(valor_precio))) {
          return 0;
        }
        if (Math.abs(a-parseFloat(valor_precio)) < Math.abs(parseFloat(b-valor_precio))) {
          return -1;
        }
        return 1;
      });
      res["res"].forEach(element => {
        element["confirmarEliminacion"]=false;
      });
      setDatos_IMAGENES(res["res"]);
    }
    const avanzarPagina=async()=>{
      if(ContPag+1>=props.Resultados/25) return;
      let res_datos_fila=await peticion(`/datos_fila?fechainicio=${fechaDB(props.date1)}&fechafin=${fechaDB(props.date2)}&variables_columna=${props.Columnas}&variable_nivel=${props.Nivel}&ini=${(ContPag+1)*25}`, {method:'POST',json:props.Confs});
      if(res_datos_fila?.estado??true) return
      setDatosFila(res_datos_fila["res"]);
      setDatosFilaExpan(null);
      setContPag(ContPag+1);
    }

    const retrocederPagina=async()=>{
      if(ContPag-1<0) return;
      let res_datos_fila=await peticion(`/datos_fila?fechainicio=${fechaDB(props.date1)}&fechafin=${fechaDB(props.date2)}&variables_columna=${props.Columnas}&variable_nivel=${props.Nivel}&ini=${(ContPag-1)*25}`, {method:'POST',json:props.Confs});
      if(res_datos_fila?.estado??true) return
      setDatosFila(res_datos_fila["res"]);
      setDatosFilaExpan(null);
      setContPag(ContPag-1);
    }

    const irPagina=async(pag)=>{
      let res_datos_fila=await peticion(`/datos_fila?fechainicio=${fechaDB(props.date1)}&fechafin=${fechaDB(props.date2)}&variables_columna=${props.Columnas}&variable_nivel=${props.Nivel}&ini=${(pag)*25}`, {method:'POST',json:props.Confs});
      if(res_datos_fila?.estado??true) return
      setDatosFila(res_datos_fila["res"]);
      setDatosFilaExpan(null);
      setContPag(pag);
    }

    async function vincular_imagen(id_imagen_, contador_, id_empresa_, valor_precio){ 
      let res=await peticion(`/vincularimagen`, {method:'POST',json: {id_imagen: id_imagen_, contador: contador_, id_cod_ent: id_empresa_}});
      if(res?.estado??true) return

      DatosFila[Seleccionado]["vinculada"]=true;

      res=await peticion(`/imagenenvinculada`, {method:'POST',json: {id_operacion: contador_, id_cod_ent: id_empresa_}});
      if(res?.estado??true) return
      setImagenAuxiliar(res["res"]);

      res=await peticion(`/bajarimagenes`, {method:'POST',json:props.Confs});
      if(res?.estado??true) return
      res["res"].sort((a, b) => {
        a = parseFloat(a["importe"]);
        b = parseFloat(b["importe"]);
        if (Math.abs(a-parseFloat(valor_precio)) === Math.abs(b-parseFloat(valor_precio))) {
          return 0;
        }
        if (Math.abs(a-parseFloat(valor_precio)) < Math.abs(parseFloat(b-valor_precio))) {
          return -1;
        }
        return 1;
      });
      res["res"].forEach(element => {
        element["confirmarEliminacion"]=false;
      });
      setDatos_IMAGENES(res["res"]);

      

    }
    async function desvincular_imagen(id_imagen_, valor_precio){      
      let res=await peticion(`/desvincularimagen`, {method:'POST',json: {id_imagen: id_imagen_}});
      if(res?.estado??true) return

      setImagenAuxiliar(null);
      DatosFila[Seleccionado]["vinculada"]=null;

      res=await peticion(`/bajarimagenes`, {method:'POST',json:props.Confs});
      if(res?.estado??true) return
      res["res"].sort((a, b) => {
        a = parseFloat(a["importe"]);
        b = parseFloat(b["importe"]);
        if (Math.abs(a-parseFloat(valor_precio)) === Math.abs(b-parseFloat(valor_precio))) {
          return 0;
        }
        if (Math.abs(a-parseFloat(valor_precio)) < Math.abs(parseFloat(b-valor_precio))) {
          return -1;
        }
        return 1;
      });
      res["res"].forEach(element => {
        element["confirmarEliminacion"]=false;
      });
      setDatos_IMAGENES(res["res"]);

      
    }
    async function imagen_vinculada(id_imagen_, id_empresa_){      
      let res=await peticion(`/imagenenvinculada`, {method:'POST',json: {id_operacion: id_imagen_, id_cod_ent: id_empresa_}});
      if(res?.estado??true) return
      setImagenAuxiliar(res["res"]);
    }
    async function imagen_vinculada2(id_imagen_, id_empresa_, valor_precio){
      DatosFila[Seleccionado]["vinculada"]=true;
      let res=await peticion(`/imagenenvinculada`, {method:'POST',json: {id_operacion: id_imagen_, id_cod_ent: id_empresa_}});
      if(res?.estado??true) return
      setImagenAuxiliar(res["res"]);

      res=await peticion(`/bajarimagenes`, {method:'POST',json:props.Confs});
      if(res?.estado??true) return
      res["res"].sort((a, b) => {
        a = parseFloat(a["importe"]);
        b = parseFloat(b["importe"]);
        if (Math.abs(a-parseFloat(valor_precio)) === Math.abs(b-parseFloat(valor_precio))) {
          return 0;
        }
        if (Math.abs(a-parseFloat(valor_precio)) < Math.abs(parseFloat(b-valor_precio))) {
          return -1;
        }
        return 1;
      });
      res["res"].forEach(element => {
        element["confirmarEliminacion"]=false;
      });
      setDatos_IMAGENES(res["res"]);
    }
    async function eliminar_imagen(id_imagen_, Imagen, valor_precio){
      let aux=Datos_IMAGENES;
      setDatos_IMAGENES(Datos_IMAGENES.splice(Imagen, 1));
      let res=await peticion(`/eliminar_imagen`, {method:'POST',json: {id_imagen: id_imagen_}});
      if(res?.estado??true){
        setDatos_IMAGENES(aux);
        return
      } 
      res=await peticion(`/bajarimagenes`, {method:'POST',json:props.Confs});
      if(res?.estado??true) return
      res["res"].sort((a, b) => {
        a = parseFloat(a["importe"]);
        b = parseFloat(b["importe"]);
        if (Math.abs(a-parseFloat(valor_precio)) === Math.abs(b-parseFloat(valor_precio))) {
          return 0;
        }
        if (Math.abs(a-parseFloat(valor_precio)) < Math.abs(parseFloat(b-valor_precio))) {
          return -1;
        }
        return 1;
      });
      res["res"].forEach(element => {
        element["confirmarEliminacion"]=false;
      });
      setDatos_IMAGENES(res["res"]);
    }
    async function guardar_comentario(contador_, id_empresa_, comentario_){      
      let res=await peticion(`/guardar_comentario`, {method:'POST',json: {contador: contador_, cod_ent: id_empresa_, comentario: comentario_ || ""}});
      if(res?.estado??true) return
      setSinComentario(false);
      setGuardarComentario(true);
      const timer = setTimeout(() => {
        // Aquí puedes colocar el código que deseas ejecutar después de 5 segundos
        setGuardarComentario(1);
      }, 2000);
      return () => clearTimeout(timer);
    }

  if (!props.show|!props.Confs|!props.date1|!props.date2|!props.Fila)
    return("")
  else
    return (
      <Modal 
      show={props.show}
      onHide={props.onHide}
      animation={false}
      centered
      className="modalpagos"
      >
        <Modal.Body >      
          <div className="col-xs-12 nopadding" >           
             <div className="col-xs-12 titular_modal">
                  <div className="col-xs-6 nopadding" >
                    <div className="titular_modal mt-n1">
                      <img src={ticketimg} alt="ticketimg"></img>
                      <div className=" nopadding">
                        <h2>Pagos</h2>
                        <h6>
                          {props.Fila}
                        </h6>
                       </div>
                       </div>
                   </div>
                  <div className="col-xs-6 nopadding" >
                  <div className="contaspacierre">
                    <div
                        onClick={() => {
                          cierra();
                        }}
                        className="aspacierre"
                      >
                        <img src={cerrar} alt="Cerrar" className="icocerrar" />
                        
                      </div>
                  </div>
                  </div>
              </div>
            </div>         
            <div className={Seleccionado === -1 ? ("col-xs-12 navfiltros"):("col-xs-8 navfiltros")}>
                 <div className="col-xs-7 nopadding">
                 <div className="col-xs-12 nopadding">
                 <div className="col-xs-12 nopadding">
                    <div className="col-xs-12 navfiltros_fechas">
                        Del <strong>{fechaEsp(props.date1)}</strong> al{" "}
                        <strong>{fechaEsp(props.date2)}</strong>
                    </div>
                    <div className="col-xs-12 navfiltros_applied">
                    <p>Filtros aplicados:</p>
                    <ul>
                      {/* IMPLEMENTAR VISUALIZACION DE FILTROS NUEVA */}
                      {/* {
                      props.Confs.filtros_ && Object.keys(props.Confs.filtros_).map(
                        (elem, i) =>
                        (
                          <Fragment key={elem+i}>
                          <li key={i}>
                            <div className="info1">{props.Confs.filtros_[elem]["titulo_"]} {props.Confs.filtros_[elem]["oper_"]} {props.Confs.filtros_[elem]["valor_"]}</div>
                              <img
                              src={aspa2}
                              className="aspa"
                              alt=""  
                              onClick={() => {
                                // let aux ={...Confs};
                                // aux.filtros_ = aux.filtros_.filter(function(i) { return i !== Confs.filtros_[elem] }); // filtramos
                                // setConfs(aux);
                              }}
                              style={{cursor:'pointer'}}
                              />
                          </li>
                          <li key={i+1} className="Y_O_filtro">
                            {props.Confs.filtros_.length>1 && i<props.Confs.filtros_.length-1 && props.Confs.filtros_[elem]["nexo_"]}
                          </li>
                          </Fragment>
                          
                        )
                      )
                      } */}
                      {props.Confs && props.Confs.filtros_ && props.Confs.filtros_.filtros_ &&
                        props.Confs.filtros_.filtros_.map((elem1, i) => (
                          <Fragment key={i}>
                            {i !== 0 && (
                              <button className="y_o" style={{ cursor: "default" }}>
                                <span>{props.Confs.filtros_.nexo}</span>
                              </button>
                            )}
                            <li
                              className="filtro"
                              onClick={() => {
                                // setModalFiltro(true);
                              }}>
                              <div className="filtro_added_oy flex-row">
                                {/* <div className="insert_filtro text-center">
                                  Agrupación de filtro
                                </div> */}
                                {/* <div className="alineaflex"> */}
                                  {elem1.filtros_.map((elem2, j) => (
                                    <Fragment key={j}>
                                      <ul>
                                        <li
                                          // style={{ cursor: "pointer" }}
                                          className="filtro info2">
                                          {elem2["titulo_"]} 
                                          {elem2["oper_"]} 
                                          {(elem2["tipo_"] === "moneda" || elem2["tipo_"] === "numero")? (elem2["valor_"]) : (elem2["titulo"])}
                                        </li>
                                      </ul>
                                      {elem1.filtros_.length - 1 !== j && (
                                        <button 
                                        style={{ cursor: "default" }}
                                        className="y_o">
                                          <span>{elem1.nexo}</span>
                                        </button>
                                      )}
                                    </Fragment>
                                  ))}
                                {/* </div> */}
                              </div>
                            </li>
                          </Fragment>
                        ))}
                    </ul>
                    </div>
                    </div>
                    </div>
                </div>
                <div className="col-xs-5 col-xs-12 alignright nopadding">
                <div className="col-xs-12 nopadding">
                    <div className="navfiltros_applied">
                         <p>Mostrando:</p><strong className="azul">{DatosFila.length ? (
                            DatosFila.length
                          ) : (
                            0                        
                          )}</strong> resultados de 
                          <strong className="azul">{props.Resultados}</strong>
                    </div>
                </div>
                <div className="col-xs-12 alignright nopadding">
                  <nav aria-label="...">
                      <ul className="pagination">
                        <li 
                          className={"page-item " + (ContPag===0?"disabled":"")}
                          onClick={()=>{setSeleccionado(-1);retrocederPagina()}}
                          disabled={ContPag===0}
                          key="anterior"
                        >
                          <p className="page-link" tabIndex="-1" style={{cursor:'pointer'}} >Anterior</p>
                        </li>
                        {ContPag!==0 && ContPag>=2 &&
                          <li 
                            className={"page-item "}
                            onClick={()=>{setSeleccionado(-1);irPagina(0)}}
                            key="ant1"
                          >
                            <p className="page-link" style={{cursor:'pointer'}} >{1}</p>
                          </li>
                        }
                        {ContPag!==0 && (parseInt((props.Resultados/25)))>3 && ContPag>=2 &&
                        <li 
                          className={"page-item "}
                          key="...0"
                          style={{pointerEvents: 'none'}}
                        >
                          <p className="page-link" style={{cursor:'pointer'}} >...</p>
                        </li>
                        }
                        {ContPag!==0 &&
                          <li 
                            className={"page-item "}
                            onClick={()=>{setSeleccionado(-1);irPagina(ContPag-1)}}
                            key="ant"
                          >
                            <p className="page-link" style={{cursor:'pointer'}} >{ContPag}</p>
                          </li>
                        }
                        <li 
                          className={"page-item active"}
                          key="med"
                        >
                          <p className="page-link" style={{cursor:'pointer'}} >{ContPag+1}</p>
                        </li>
                        {parseInt((props.Resultados/25))!==ContPag &&
                          <li 
                            className={"page-item "}
                            onClick={()=>{setSeleccionado(-1);irPagina(ContPag+1)}}
                            key="sig"
                          >
                            <p className="page-link" style={{cursor:'pointer'}} >{ContPag+2}</p>
                          </li>
                        }
                        {ContPag===0 && parseInt((props.Resultados/25))!==ContPag && (parseInt((props.Resultados/25))+1)!==(ContPag+2) &&
                          <li 
                            className={"page-item "}
                            onClick={()=>{setSeleccionado(-1);irPagina(ContPag+2)}}
                            key="sig2"
                          >
                            <p className="page-link" style={{cursor:'pointer'}} >{ContPag+3}</p>
                          </li>
                        }
                        {(parseInt((props.Resultados/25)))!==ContPag && (parseInt((props.Resultados/25)))>3 && ContPag<(parseInt((props.Resultados/25)))-1 &&
                        <li 
                          className={"page-item "}
                          key="..."
                          style={{pointerEvents: 'none'}}
                        >
                          <p className="page-link" style={{cursor:'pointer'}}  >...</p>
                        </li>
                        }
                        {ContPag!==(parseInt((props.Resultados/25))) && ContPag<(parseInt((props.Resultados/25)))-1 && parseInt((props.Resultados/25))>3 &&
                          <li 
                            className={"page-item "}
                            onClick={()=>{setSeleccionado(-1);irPagina((parseInt((props.Resultados/25))))}}
                            key="antultima"
                          >
                            <p className="page-link" style={{cursor:'pointer'}} >{(parseInt((props.Resultados/25)))+1}</p>
                          </li>
                        }
                        <li 
                          className={"page-item " + (ContPag===(parseInt((props.Resultados/25)))?"disabled":"")} 
                          onClick={()=>{setSeleccionado(-1);avanzarPagina()}}
                          disabled={ContPag === parseInt((props.Resultados/25))}
                          key="siguiente"
                        >
                          <p className="page-link" style={{cursor:'pointer'}}  >Siguiente</p>
                        </li>
                      
                      </ul>
                    </nav>

                    </div>
                   
                </div>
            
            </div>
            {
            Seleccionado !== -1 &&
            <div className="col-xs-4 cabeceraadjunto">
              <button className="cierralateral" onClick={()=>{
                setSeleccionado(-1);
                setDatosFilaExpan(null);
                setSinComentario(true);
              }}>Cerrar<i className="fa-solid fa-xmark"></i></button>
            </div>
            }      
            <div className="col-xs-12 reversemovil">   
              <div className={Seleccionado === -1 ? ("col-xs-12 tabla"):("col-xs-8 tabla")}> 
                    <div className="col-xs-12 cabeceratabla">
                      <div className="col-xs-12 cont_cabeceratabla">
                        <table>
                          <tbody>                        
                            <tr>
                              <td key={1} >Nombre del comercio <i className="fa-solid fa-bag-shopping"></i></td>
                              <td key={2} className="numeros">Fecha <i className="fa-solid fa-calendar"></i></td>
                              <td key={3} className="numeros">Importe <img src={equal} alt="equal" className="equal"/></td>
                              <td key={4} className="numeros">Adjunto <i className="fa-solid fa-paperclip"></i></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>               
                    </div>
                    {DatosFila.length===0 ? (
                      <div className="col-xs-12 cont_tabladatos">
                        <div className="col-xs-12 preloaderkpi">
                          Cargando...<img src={carga} style={{ width: '10px', height: '10px' }} alt='Cargando' />
                        </div>
                      </div>
                    ):(
                    <div className="col-xs-12 cont_tabladatos">
                        <table
                        width="100%"
                        border="0"
                        cellSpacing="5"
                        cellPadding="5"
                        className="tabladatos"
                        >
                            <tbody ref={divSeleccionar}>
                            {
                                DatosFila && DatosFila.map(
                                    (elem1, i) =>
                                    (
                                      <Fragment key={elem1+i}>
                                      <tr
                                      className={i === Seleccionado ? (i%2===0 ? ("marcado class_aux"):("marcado")):(i%2===0 ? ("class_aux"):(""))}
                                      key={i}
                                      onClick={() => {
                                        setDatosFilaExpan(null);
                                        setDatos_IMAGENES(null);
                                        imagenes2(elem1["i6operacion.importe_liqui"]);
                                        datos_fila_expe(elem1["i6operacion.contador"], elem1["i6operacion.cod_ent"]);
                                        setSeleccionado(i);
                                        setComentario(elem1["i6operacion.descripcion"]);
                                        setSinComentario(true);
                                        if(elem1["vinculada"]===true){                            
                                          imagen_vinculada(elem1["i6operacion.contador"], elem1["i6operacion.cod_ent"]);
                                        }
                                      }}
                                      style={{cursor:'pointer'}}
                                      >
                                        {
                                        Confs.campos && Confs.campos.map(
                                            (elem2,j) =>
                                            (
                                              <Fragment 
                                              key={j+i}                                               
                                              >
                                                {elem2==="i6operacion.nombre_comercio" &&
                                                  <td className="" key={j}>
                                                    {elem1[elem2]}
                                                  </td>
                                                }
                                                {elem2==="i6operacion.importe_liqui" && 
                                                  <td className="numeros" key={elem2+i}>
                                                  {elem1[elem2]+"€"}
                                                  </td>
                                                }
                                                {elem2==="i6operacion.fecha_ope" && 
                                                  <td className="numeros" key={elem2}>        
                                                    {fechaMostrar(elem1[elem2])}
                                                  </td>
                                                }
                                                {elem2==="adjunto" &&                     
                                                <td key={elem2+elem1+i+j} className="numeros">
                                                  {elem1["vinculada"]!==null && (
                                                    <span>
                                                      <i className={i === Seleccionado ? ("fa-solid fa-paperclip marcado") : ("fa-solid fa-paperclip sinmarcar")}></i>
                                                    </span>
                                                  )
                                                  }
                                                </td>
                                                }
                                              </Fragment>                                            
                                            )
                                        )
                                        }
                                      </tr>
                                      { Seleccionado !== -1 && Seleccionado===i && DatosFilaExpan!==null &&
                                        <tr className="detalles" ref={divSeleccionar2}>
                                          <td colSpan={2}>
                                            <div className="col-xs-12 confondo nopadding">
                                            <div className="col-xs-12 nopadding izq">
                                                <ul>
                                                  <li>
                                                    <span><p>Titular de la tarjeta</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["i6titular.nombre_titu"]?? ""}</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>Nif del titular</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["i6titular.nif_titu"]??""}</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>Número de la tarjeta</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["i6operacion.pan_mask"]??""}</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>Tipo de operación</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["i6tipo_ope.nombre_ope"]??""}</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>Fecha de la operación</p></span>
                                                    <span><p>{fechaMostrar(DatosFilaExpan[0]?.["i6operacion.fecha_ope"]??"")}</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>Importe en euros</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["i6operacion.importe_liqui"]??""}€</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>Importe en moneda origen</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["i6operacion.importe_ope"]??""}</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>País</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["i6operacion.pais_ori"]??""}</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>Comercio</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["i6operacion.nombre_comercio"]??""}</p></span>
                                                  </li>
                                                  <li>
                                                    <span><p>Actividad del comercio</p></span>
                                                    <span><p>{DatosFilaExpan[0]?.["clase_actividad_eb.des_clase_activ"]??""}</p></span>
                                                  </li>
                                                </ul>
                                            </div>
                                            </div>
                                          </td>
                                          <td colSpan={2}>
                                            <div className="col-xs-12 confondo nopadding">
                                              <div className="col-xs-12 nopadding de">                                              
                                                <div className="col-xs-12 conterror_ul">
                                                  {GuardarComentario !== 1 && !SinComentario &&
                                                    <div className={GuardarComentario===false? 'error col-xs-8 warning':'error col-xs-8 verde'}>
                                                        <span>                                                      
                                                        {GuardarComentario===false? (""):(<i className="fa-solid fa-check verde"></i>)}{GuardarComentario===false? 'No has guardado tu comentario':'Comentario guardado'}
                                                        </span>
                                                    </div>
                                                  }
                                                    <ul className="nav_coment col-xs-4">
                                                      <li>
                                                        <button
                                                          onClick={()=>{
                                                            //borro el comentario
                                                            guardar_comentario(DatosFila[Seleccionado]["i6operacion.contador"], DatosFila[Seleccionado]["i6operacion.cod_ent"], "");
                                                            setSinComentario(true);
                                                            setGuardarComentario(false);
                                                            setComentario("");
                                                            DatosFilaExpan[0]["i6operacion.descripcion"] = "";
                                                            DatosFila[Seleccionado]["i6operacion.descripcion"] = "";
                                                            setDatosFila([...DatosFila]);
                                                            setDatosFilaExpan([...DatosFilaExpan]); 
                                                          }}>
                                                            <span><i className="fa-solid fa-trash"></i></span>
                                                        </button>
                                                        <button
                                                          onClick={()=>{
                                                            guardar_comentario(DatosFila[Seleccionado]["i6operacion.contador"], DatosFila[Seleccionado]["i6operacion.cod_ent"], Comentario);
                                                          }}>
                                                            <span><i className="fa-solid fa-floppy-disk"></i></span>
                                                        </button>
                                                      </li>
                                                    </ul>
                                                  </div>

                                                  <textarea 
                                                  ref={divComentario}
                                                  placeholder="Comentarios"
                                                  // defaultValue={Comentario? (Comentario):(DatosFilaExpan[0]["i6operacion.descripcion"]? (DatosFilaExpan[0]["i6operacion.descripcion"]):(""))}
                                                  value={Comentario? (Comentario):(DatosFilaExpan[0]["i6operacion.descripcion"]? (DatosFilaExpan[0]["i6operacion.descripcion"]):(""))}
                                                  onChange={()=>{
                                                    setSinComentario(false);
                                                    setGuardarComentario(false);
                                                    setComentario(divComentario.current.value);
                                                  }}
                                                  />
                                                
                                                  <div className="col-xs-12 imgticket">
                                                    {!ImagenenAuxiliar && !DatosFila[Seleccionado]["vinculada"] &&
                                                    <div className="col-xs-12 sinimagenmovil">
                                                    No hay ninguna imagen enlazada.
                                                    </div>
                                                    }                                                   
                                                    <img src={(ImagenenAuxiliar && ImagenenAuxiliar["0"] && ImagenenAuxiliar["0"]["archivo"] && DatosFila[Seleccionado]["vinculada"]) ? ImagenenAuxiliar["0"]?.["archivo"]??"":ticket2} alt=""/> 
                                                  </div>
                                              </div>
                                              
                                            </div>
                                            
                                          </td>
                                        </tr>
                                        }
                                      </Fragment>
                                    )
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                     )}
              </div>
              { Seleccionado !== -1 &&
              <div className="col-xs-4 pdleft15" ref={divSeleccionar2}>              
                  <div className="col-xs-12 cabeceraconcepto">  
                    Adjunta tu imagen
                    <img src={clip} alt="clip"/>
                  </div>

                  <div className={ImagenenAuxiliar? ('conscroll imagen_enlazada'):('conscroll')}>
                    <div className="col-xs-12 seleccionada">
                        {!DatosFila[Seleccionado]["vinculada"] &&
                        <div className="col-xs-12 carganoseleccionada">
                          <p>Por favor, seleccione una<br></br>imágen para validarla</p>
                        </div> 
                        }
                        {ImagenenAuxiliar && ImagenenAuxiliar["0"] && DatosFila[Seleccionado]["vinculada"] &&
                        <Fragment>
                          <div className="col-xs-12 cargaseleccionada">
                            <img src={ImagenenAuxiliar["0"]["archivo"]} alt="ticket validado"/>
                          </div> 
                          <div className="col-xs-12 infofotos">
                                <span>{ImagenenAuxiliar["0"]["importe"]+"€"}</span>
                                <small>{ImagenenAuxiliar["0"]["comentario"]}</small>
                          </div>
                          <span className="validado"><img src={validado} alt="validado"/></span>
                          <button 
                          className="elimina" 
                          alt="elimina"
                          onClick={() => {                           
                            desvincular_imagen(ImagenenAuxiliar["0"]["id"], DatosFila[Seleccionado]["i6operacion.importe_liqui"]);
                            
                            // imagenes2(DatosFila[Seleccionado]["i6operacion.importe_liqui"]);
                          }}
                          >
                              <span><i className="fa-solid fa-link-slash"></i></span>
                          </button>
                        </Fragment>
                        }
                    </div>
                    
                    {!DatosFila[Seleccionado]["vinculada"] &&
                    <div className="col-xs-12 fotos" ref={divSeleccionar3}>
                        {<ModalSubirImagenes
                        show={modalSubirImagnes}
                        onHide={() => setModalSubirImagnes(false)}
                        referencia={divSeleccionar4}
                        auxiliar={true}
                        id_operacion={DatosFila[Seleccionado]["i6operacion.contador"]?(DatosFila[Seleccionado]["i6operacion.contador"]):("")}
                        id_cod_ent={DatosFila[Seleccionado]["i6operacion.cod_ent"]?(DatosFila[Seleccionado]["i6operacion.cod_ent"]):("")}
                        setImagenAuxiliar={setImagenAuxiliar}
                        setmodalSubirImagnesAux={setmodalSubirImagnesAux}
                        />}
                        <div className="col-xs-12 sinsubir">
                              <ul>
                                <li>
                                <div className="col-xs-12 subirotra">
                                      <button 
                                      className="subirbtn" 
                                      alt="subir otra"
                                      onClick={()=>{
                                      setModalSubirImagnes(true);
                                      }}
                                      >
                                        <img src={plus} alt=""/>
                                        <span>Subir otra</span>
                                      </button> 
                                      
                                    </div> 
                                </li>
                                {Datos_IMAGENES &&
                                Datos_IMAGENES.map(
                                  (elem, i) =>(
                                    <li key={i}>
                                      {elem["confirmarEliminacion"]===false &&
                                      <Fragment key={elem}>
                                        <div className="col-xs-12 capa1">
                                        <button
                                          className="eliminaimagen" 
                                          onClick={()=>{                                            
                                            elem["confirmarEliminacion"]=true; 
                                            setDatos_IMAGENES(Datos_IMAGENES.slice());             
                                        }}><img src={cerrar_conbg} alt="Eliminar" className="icocerrar" /></button>

                                      </div>
                                      <div className="col-xs-12 capa2">
                                      <button 
                                      className="imgnosel" 
                                      alt="imagen no seleccionada"
                                      onClick={() => {                    
                                        vincular_imagen(elem["id"], DatosFila[Seleccionado]["i6operacion.contador"], DatosFila[Seleccionado]["i6operacion.cod_ent"], DatosFila[Seleccionado]["i6operacion.importe_liqui"]);                                      
                                        // DatosFila[Seleccionado]["vinculada"]=true;
                                        // imagen_vinculada(DatosFila[Seleccionado]["i6operacion.contador"], DatosFila[Seleccionado]["i6operacion.cod_ent"]);                            
                                        // imagenes2(DatosFila[Seleccionado]["i6operacion.importe_liqui"]);
                                      }}
                                      ><span><img src={elem["archivo"]} alt=""/></span></button>
                                      <div className="pd10">
                                      <div className="importe"><div className="arriba">Importe:</div><div className="abajo"><strong>{elem["importe"]+"€"}</strong></div></div>
                                      <div className="comentario"><div className="arriba">Comentario:</div><div className="abajo"><strong>{elem["comentario"]}</strong></div></div>
                                      </div>
                                      </div>
                                    </Fragment>
                                  }
                                  {
                                    elem["confirmarEliminacion"]===true &&
                                    <div className="col-xs-12 capa3_safe prueba234">
                                    <div className="safe">
                                      <p>¿Estás seguro de eliminar esta imagen?</p>
                                      <div className="safenav">
                                        <button 
                                        className="safenavsi" 
                                        onClick={()=>{
                                          elem["confirmarEliminacion"]=false;
                                          eliminar_imagen(elem["id"], elem, DatosFila[Seleccionado]["i6operacion.importe_liqui"]);
                                          // imagenes2(DatosFila[Seleccionado]["i6operacion.importe_liqui"]);
                                          // setDatos_IMAGENES(Datos_IMAGENES.slice());
                                          }}
                                        >sí</button>
                                        <button 
                                        className="safenavno"
                                        onClick={()=>{
                                          elem["confirmarEliminacion"]=false;
                                          setDatos_IMAGENES(Datos_IMAGENES.slice());
                                          }}
                                        >no</button>
                                      </div>
                                    </div>
                                    </div>
                                  }
                                    
                                   
                                   
                                    </li>
                                  ))
                                }
                              </ul>
                        </div>
                    </div>
                    }
                  </div>
              </div>
              }
            </div>   
        </Modal.Body>
      </Modal>
    )
}

export default ModalPorTipo;